/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcCostbasisV1TaxLotState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_COSTBASIS_V1_TAX_LOT_STATE_ENTITY_NAME = 'ixc.costbasis.v1.TaxLot';
export const ixcCostbasisV1TaxLotStateEntity = new schema.Entity<IxcCostbasisV1TaxLotState>(IXC_COSTBASIS_V1_TAX_LOT_STATE_ENTITY_NAME, {}, { idAttribute: 'taxLotId' });

